import { Link } from "react-router-dom";
import { useLanding } from "@/hooks/useLanding";

/**
 * Footer.
 *
 * Sengaja TIDAK menyebut stack (Cloudflare, D1, edge-runtime, versi build).
 * Detail infrastruktur tidak berarti apa-apa bagi pembeli dan hanya membuat
 * toko terlihat seperti demo internal.
 */

const LINKS = [
  { to: "/products", label: "Katalog" },
  { to: "/dashboard", label: "Akun Saya" },
  { to: "/terms", label: "Syarat & Ketentuan" },
  { to: "/privacy", label: "Kebijakan Privasi" },
];

export function Footer() {
  const { data } = useLanding();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-border bg-surface mt-20">
      <div className="max-w-7xl mx-auto px-4 py-10 flex flex-col md:flex-row md:items-start md:justify-between gap-8">
        <div className="max-w-sm">
          <div className="font-heading text-lg font-extrabold tracking-tight text-ink-primary">
            AG5R<span className="text-accent">.</span>STORE
          </div>
          <p className="mt-2 font-sans text-sm text-ink-muted leading-relaxed">
            {data?.footer_tagline || "Lisensi digital yang langsung aktif setelah bayar."}
          </p>
        </div>

        <nav className="flex flex-wrap gap-x-8 gap-y-3">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="font-sans text-sm text-ink-muted hover:text-accent transition-colors"
            >
              {l.label}
            </Link>
          ))}
        </nav>
      </div>

      <div className="border-t border-border">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <p className="font-sans text-xs text-ink-dim">© {year} AG5R.STORE</p>
        </div>
      </div>
    </footer>
  );
}
